/* eslint-disable no-unused-vars */
import DefectPage from "layout/DefectPage";
import ImgAccessDenied from "assets/image/access denied.png";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AccessDenied = () => {
  const { t } = useTranslation(["translation"]);
  const history = useHistory();

  return (
    <DefectPage
      title={t("defect.403.title")}
      image={ImgAccessDenied}
      alt={"access denied"}
      descript={t("defect.403.desc")}
      onSubmit={()=>history.push("/mainmenu")}
      submit={t("backmain")}
      icon={undefined}
    />
  );
};

export default AccessDenied;
